import {SectorType} from "crqlar-react-common/dist/models/sector/sector.model";
import {useCurrentApp} from "crqlar-react-common/dist/utils/hooks/app/useOrganizationApps";
import {useSector} from "crqlar-react-common/dist/utils/hooks/sector/useSectors";
import {useLocalize} from "crqlar-react-common/dist/utils/text.util";
import {useLocation, useParams} from "react-router-dom";
import {useSectorIcon} from "../../utils/reservation.util";
import Accommodation from "./Accommodation";
import Other from "./Other";
import Restaurant from "./Restaurant";
import Spa from "./Spa";
import WeeklyPlanner from "./WeeklyPlanner";

export default function ReservationSchedule() {
    const {t} = useLocalize();
    const {appId} = useParams<"appId">();
    const {pathname} = useLocation();
    const app = useCurrentApp();
    const sector = useSector(app?.configuration?.sectorId);
    const sectorIcon = useSectorIcon(sector);
    const basePath = pathname.split("/")[1];

    if (!appId || !app || !sector) return null;

    const appName = app.name ?? t("Reservations");
    const tabPath = (tab: string) => `/${basePath}/${tab}/${appId}`;

    if (sector.sectorType === SectorType.RESTAURANT) {
        return (
            <Restaurant
                appName={appName}
                icon={sectorIcon}
                tabPath={tabPath}
                sector={sector}
            />
        );
    }

    if (sector.sectorType === SectorType.SPA) {
        return (
            <Spa
                appName={appName}
                icon={sectorIcon}
                tabPath={tabPath}
                sector={sector}
            />
        );
    }

    if (sector.sectorType === SectorType.ACCOMMODATION) {
        return (
            <Accommodation
                appName={appName}
                icon={sectorIcon}
                tabPath={tabPath}
                sector={sector}
            />
        );
    }

    if (sector.sectorType === SectorType.WEEKLY_PLANNER) {
        return (
            <WeeklyPlanner
                appName={appName}
                icon={sectorIcon}
                tabPath={tabPath}
                sector={sector}
            />
        );
    }

    return (
        <Other
            appName={appName}
            icon={sectorIcon}
            tabPath={tabPath}
            sector={sector}
        />
    );
}
